import { render } from "./MyCertificates.vue?vue&type=template&id=028c0064"
import script from "./MyCertificates.vue?vue&type=script&lang=js"
export * from "./MyCertificates.vue?vue&type=script&lang=js"

import "./MyCertificates.vue?vue&type=style&index=0&id=028c0064&lang=scss"

import exportComponent from "/var/www/certificates-staging.paginasingeniosas.com/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__